import React from 'react';
// import '../Navigation/Navigation.scss';
import './Menu.scss';
import GenderMenu from './GenderMenu';

const Menu = props => {
    const { menuData, updateNavValueDtm, section} = props;
    const fetchMenu = menuData.data.map((data, index) => {
        const subParentKey = data;
        return Object.keys(data).map(key => {
            return (
                <div key={index} className={`nav-level-2 nav-${section}`}>
                    {data[key] && <GenderMenu genderMenuData={data[key]} menuData={subParentKey} parentKey={key} updateNavValueDtm={updateNavValueDtm} section={section} />}
                </div >
            );
        });
    });

    return (
        <div className="nav-level-acc nav-glasses">
            {fetchMenu}
        </div>
    );
};

export default Menu;
